import InvoiceDetails from "@/components/contributor/InvoiceDetails";
import ManagerApproveOrReject from "@/components/dialog/ManagerApproveOrReject";
import InvoiceSkeleton from "@/components/skeleton/InvoiceSkeleton";
import { STALE_TIME_INVOICE } from "@/constants";
import { UserContext } from "@/context/User/UserContext";
import { getSingleMasterContributorInvoice } from "@/services/external-contributors-functions";
import { useContext } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";

const ManagerContributorApproval = () => {
	const { id } = useParams<{ id: string }>() as { id: string };
	const user = useContext(UserContext);

	const masterInvoice = useQuery({
		queryKey: ["master-invoice", id],
		queryFn: () => getSingleMasterContributorInvoice(user?.accessToken!, id),
		staleTime: STALE_TIME_INVOICE,
		enabled: !!user?.accessToken,
	});

	return (
		<div>
			{masterInvoice.isLoading ? (
				<InvoiceSkeleton />
			) : masterInvoice.isError ? (
				<div className="align-centre">
					<h5 className="text-center">Error loading invoice.</h5>
				</div>
			) : masterInvoice.data ? (
				<>
					<div className="flex gap-3 items-end justify-between mb-2">
						<h1 className="font-medium text-4xl">
							CLAIM NO: {masterInvoice.data.invoicemasterid}
						</h1>
						<ManagerApproveOrReject
							invoicemasterid={masterInvoice.data.invoicemasterid}
							accessToken={user?.accessToken!}
						/>
					</div>
					<InvoiceDetails
						invoice={masterInvoice.data}
						accessToken={user?.accessToken!}
					/>
				</>
			) : null}
		</div>
	);
};

export default ManagerContributorApproval;
